// src/link.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var Link = React.forwardRef(
  ({ target = "_blank", style, ...props }, forwardedRef) => /* @__PURE__ */ jsx(
    "a",
    {
      ...props,
      ref: forwardedRef,
      "data-id": "react-email-link",
      target,
      style: {
        color: "#067df7",
        textDecoration: "none",
        ...style
      }
    }
  )
);
Link.displayName = "Link";
export {
  Link
};
